(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (function () {
    const mq = window.matchMedia('(max-width: 1023px)');

    // On mobile: tear down the in-card slider entirely so it can NEVER
    // intercept touches that belong to the parent product-row slider.
    //   • remove every image link after the first → only the featured
    //     photo stays in the DOM (lazy-loaded siblings never fetch)
    //   • remove the prev/next nav buttons (display:none already
    //     hides them, but get them out of the DOM too)
    //   • strip data-card-images so the desktop slider init below
    //     can't find a track even if mq.matches flips later
    function teardownMobile(card) {
      const track = card.querySelector('[data-card-images]');
      if (track) {
        track.querySelectorAll(':scope > .product-card__image-link').forEach((link, i) => {
          if (i > 0) link.remove();
        });
        track.removeAttribute('data-card-images');
      }
      card.querySelectorAll('.product-card__nav').forEach((btn) => btn.remove());
    }

    function bindDesktopSlider(card) {
      const track = card.querySelector('[data-card-images]');
      if (!track) return;
      const prev = card.querySelector('[data-card-prev]');
      const next = card.querySelector('[data-card-next]');
      const step = () => track.clientWidth || 0;
      prev && prev.addEventListener('click', (e) => {
        e.preventDefault();
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
      next && next.addEventListener('click', (e) => {
        e.preventDefault();
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });

      // Chrome / WebKit convert a vertical wheel delta into horizontal
      // scroll on any element with overflow-x: auto. That means
      // scrolling the page while hovering a multi-image product card
      // would scroll the card sideways instead of the page. We
      // intercept wheel events and forward pure-vertical deltas to the
      // window. Horizontal deltas (e.g. shift+wheel or trackpad
      // sideways) still scroll the slider as the user expects.
      track.addEventListener('wheel', (e) => {
        const absY = Math.abs(e.deltaY);
        const absX = Math.abs(e.deltaX);
        if (absY > absX) {
          e.preventDefault();
          window.scrollBy({ top: e.deltaY, left: 0, behavior: 'auto' });
        }
      }, { passive: false });
    }


    // Colección v3: fotos deslizables en móvil. Las fotos extra no llevan src hasta que hacen falta:
    // la 2.ª con la tarjeta en pantalla, tras cargar la página; el resto al tocar. En iPhone,
    // loading=lazy dentro del carrusel dejaba la foto en blanco al deslizar.
    function showImg(img, lazy) {
      if (!img || !img.dataset.srcset) return;
      if (!lazy) img.loading = 'eager';
      img.srcset = img.dataset.srcset;
      img.src = img.dataset.src;
      delete img.dataset.srcset;
    }
    const nearIO = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (!e.isIntersecting) return;
        nearIO.unobserve(e.target);
        if (mq.matches) showImg(e.target.querySelectorAll('[data-card-images] img')[1]);
      });
    }, { threshold: 0.1 });
    function bindMobileGallery(card) {
      const track = card.querySelector('[data-card-images]');
      if (!track || track.dataset.mobileBound) return;
      track.dataset.mobileBound = '1';
      if (document.readyState === 'complete') nearIO.observe(card);
      else window.addEventListener('load', () => nearIO.observe(card), { once: true });
      const showAll = () => track.querySelectorAll('img').forEach((img) => showImg(img));
      const dots = card.querySelectorAll('.product-card__dots > span');
      let pending = false;
      track.addEventListener('scroll', () => {
        showAll();
        if (pending || !dots.length) return;
        pending = true;
        requestAnimationFrame(() => {
          pending = false;
          const i = Math.round(track.scrollLeft / (track.clientWidth || 1));
          dots.forEach((d, n) => d.classList.toggle('is-active', n === i));
        });
      }, { passive: true });
      track.addEventListener('touchstart', () => {
        track.dataset.touched = '1';
        track.classList.remove('is-peeking');
        showAll();
      }, { passive: true, once: true });
    }

    function initCard(card) {
      if (card.hasAttribute('data-card-mobile')) bindMobileGallery(card);
      if (mq.matches && !card.hasAttribute('data-card-mobile')) teardownMobile(card);
      else if (!mq.matches) { card.querySelectorAll('img[data-srcset]').forEach((img) => showImg(img, true)); bindDesktopSlider(card); }
    }

    document.querySelectorAll('[data-card]').forEach(initCard);

    // AJAX-injected cards (Load More, cart refresh, etc.) get the same
    // treatment. Cheap MutationObserver scoped to body.
    const mo = new MutationObserver((mutations) => {
      mutations.forEach((m) => {
        m.addedNodes.forEach((n) => {
          if (n.nodeType !== 1) return;
          if (n.matches && n.matches('[data-card]')) initCard(n);
          n.querySelectorAll && n.querySelectorAll('[data-card]').forEach(initCard);
        });
      });
    });
    mo.observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
